module.exports = __webpack_public_path__ + "d1977fb003dcc23c0f83884aa75aa9d2.svg";